var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.8 65.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.15 14.65 48.49 29.31 45.82 26.63 44.51 25.32 51.2 18.64 0 18.64 0 10.56 51.07 10.56 44.51 3.99 45.82 2.68 48.49 0 63.15 14.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.67,
    y: 11.18,
    width: 29.31,
    height: 6.95,
    transform: "translate(55.67 84.98) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.65 50.85 25.31 65.51 27.98 62.83 29.29 61.52 22.6 54.84 73.8 54.84 73.8 46.76 22.73 46.76 29.29 40.19 27.98 38.88 25.31 36.2 10.65 50.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -11.18,
    y: 47.37,
    width: 29.31,
    height: 6.95,
    transform: "translate(-47.37 54.33) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab);
export default __webpack_public_path__ + "static/media/tab.f29effc07d3f9775cb992214986b01b4.svg";
export { ForwardRef as ReactComponent };